<template>
  <div class="box" v-if="!loading">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-5">
            Metaphor Representations
          </p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-tooltip label="Section Enabled" v-if="toggleable">
            <b-switch v-model="enabled" v-on:input="doCallback"></b-switch>
          </b-tooltip>
        </div>
      </div>
    </div>
    <div v-bind:class="['selectors', enabled ? '' : 'disabled']">
      <div
        v-for="(metaphorItems, name) in metaphors"
        v-bind:key="name"
      >
        <b-collapse
          class="card"
          animation="slide"
          v-bind:open="true"
        >
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button">
            <p class="card-header-title">
              {{ name }}
            </p>
          </div>
          <div class="card-content">
            <div class="content">
              <div
                v-for="(metaphor, index) in metaphorItems"
              >
                <div class="field">
                  <b-checkbox
                    size="is-small"
                    v-model="metaphor.active"
                    v-on:input="doCallback">
                    {{ metaphor.metaphor }}
                  </b-checkbox>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiFetch } from '../../../api/api';

  export default {
    data() {
      return {
        metaphors: {},
        loading: true,
        enabled: true,
      }
    },
    props: {
      activeValues: Array,
      portfolio: Object,
      benchmark: Object,
      callback: Function,
      toggleable: {
        type: Boolean,
        default: false,
      }
    },
    local: {
      portfolioId: null, // Used to prevent refreshing applicable metaphors from the server when the portfolio itself hasn't changed.
    },
    components: {},
    methods: {
      doCallback: function() {
        this.callback.call(
          this,
          [].concat(...Object.values(this.metaphors)).filter((itm) => {return itm.active === true}),
          this.enabled,
        );
      },
      updateReportData: function() {
        console.log('Updating metaphor report data...');
        if (!this.toggleable) {
          this.enabled = true;
        }

        if (!this.enabled) {
          return;
        }

        if (!this.portfolio.id) {
          return;
        }

        this.metaphors = {};

        this.$options.local.portfolioId = this.portfolio.external_id;
        this.loading = true;
        apiFetch(`/api/v1/portfolios/${this.portfolio.external_id}${this.benchmark.external_id ? ':' + this.benchmark.external_id : ''}/report/metaphor/`)
          .then((data) => {
            return data.json();
          })
          .then((data) => {
            const metaphorsInScreenSets = [];
            this.activeValues.forEach(screenSet => {
              const metaphorsInScreenSet = screenSet.metrics.filter(metric => metric.metaphor?.id).map(metric => metric.metaphor.id);
              metaphorsInScreenSets.push(...metaphorsInScreenSet);
            });
            data.report.metrics.forEach(itm => {
              itm.active = false;
              let isFirst = false;
              if (!(itm.name in this.metaphors)) {
                this.metaphors[itm.name] = [];
                isFirst = true;
              }
              if (metaphorsInScreenSets.length > 0) {
                itm.active = metaphorsInScreenSets.includes(itm.metaphor_id);
              } else if (itm.is_good && isFirst) {
                itm.active = true;
              }
              this.metaphors[itm.name].push(itm);
            });
            this.loading = false;
            this.doCallback();
          });
      },
    },
    watch: {
      benchmark: function() {
        this.updateReportData();
      },
      activeValues() {
        this.updateReportData();
      },
    },
    computed: {},
    created: function() {
      this.updateReportData();
    },
  }
</script>

<style lang="scss" scoped>
.selectors {
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
}
</style>
